// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"vha-z","displaySixCardTiles":"wha-z"};